import { useSearchParams } from "react-router-dom";
import { ALL, NONE } from "@miplatform/constants";
import { HomeFilter } from "../types";

export const useHomeSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setFiltersInSearchParams = (filters: HomeFilter) => {
    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== ALL && value !== NONE) {
        searchParams.set(key, value as string);
      } else {
        searchParams.delete(key);
      }
    });
    setSearchParams(searchParams);
  };

  const getFiltersFromSearchParams = (): HomeFilter | null => {
    if (searchParams.size === 0) {
      return null;
    }

    return {
      groupBy: searchParams.get("groupBy") || "phase",
      sortBy: searchParams.get("sortBy") || NONE,
      builderId: searchParams.get("builderId") || ALL,
      communityId: searchParams.get("communityId") || ALL,
      phase: searchParams.get("phase") || ALL,
      latestTemplateName: searchParams.get("latestTemplateName") || ALL,
    };
  };

  const buildListUrlWithSearchParams = (filters: HomeFilter): string => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== ALL && value !== NONE) {
        params.set(key, value as string);
      }
    });
    const encodedParams = params.toString();

    return encodedParams ? `/homes/list?${encodedParams}` : `/homes/list`;
  };

  const clearSearchParams = () => {
    setSearchParams(new URLSearchParams());
  };

  return {
    searchParams,
    setSearchParams,
    setFiltersInSearchParams,
    getFiltersFromSearchParams,
    buildListUrlWithSearchParams,
    clearSearchParams,
  };
};
